module.exports = __webpack_public_path__ + "static/media/gh-map-logo-highlight.c7886533.png";